import {unichainSepolia} from "wagmi/chains"

const chainData = {...unichainSepolia}
chainData.blockExplorers.default.url = 'https://unichain-sepolia.blockscout.com'
export default chainData